import * as React from 'react';
import classnames from 'classnames';
import { ScrollIntoView } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl, useSelector, useDispatch, statusFailed, statusLoading } from '@grandvisionhq/state';
import { updatePassword } from '../actions.js';
import PasswordForm from '../../components/PasswordForm/PasswordForm.js';
import { getAuth } from '../../selectors.js';
import { isLoggedInPasswordless } from '../../state.js';

const elementName = 'set-password';
const SetPassword = ()=>{
    const { getLabel  } = useIntl();
    const auth = useSelector(getAuth);
    const dispatch = useDispatch();
    // has to be used together with statusLoading for the call to have loading state until redirect is successful
    const [redirecting, setRedirecting] = React.useState(false);
    React.useEffect(()=>{
        if (statusFailed(auth.setPasswordCall)) setRedirecting(false);
    }, [
        statusFailed,
        auth,
        setRedirecting
    ]);
    const onSubmit = (password)=>{
        setRedirecting(true);
        dispatch(updatePassword({
            password
        }));
    };
    if (!isLoggedInPasswordless(auth)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(elementName, 'myaccount__section')
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        className: classnames(`${elementName}__title`)
    }, getLabel('account.resetPassword.confirmation.title')), /*#__PURE__*/ React.createElement("p", {
        className: `${elementName}__text`
    }, getLabel('account.resetPassword.setPassword.text')), statusFailed(auth.setPasswordCall) && /*#__PURE__*/ React.createElement(ScrollIntoView, null, /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        className: "alert-m-default"
    }, getLabel('account.resetPassword.updatePassword.errors.general'))), /*#__PURE__*/ React.createElement(PasswordForm, {
        "data-t": "set-password-form",
        passwordLabel: getLabel('fields.input.password.label'),
        buttonCaption: getLabel('account.action.setPassword'),
        onSubmit: onSubmit,
        isLoading: statusLoading(auth.setPasswordCall) || redirecting
    }));
};

export { SetPassword };
//# sourceMappingURL=SetPassword.js.map
